import { BaseModelData, ShoppingContext } from '../data/model';
import { IEvent } from '../shared/EventAggregator';

export interface ConfiguratorEventFeature {
  code: string;
  name: string;
  optionCode: string;
  optionName: string;
}

export class ConfigurationViewedEvent implements IEvent {
  constructor(
    public readonly shoppingContext: ShoppingContext,
    public readonly product: BaseModelData,
    public readonly selectedFeatures: ConfiguratorEventFeature[],
  ) {}
}

export class ConfigurationFeatureChangedEvent implements IEvent {
  constructor(
    public readonly shoppingContext: ShoppingContext,
    public readonly product: BaseModelData,
    public readonly selectedFeatures: ConfiguratorEventFeature[],
    /**
     * The code of a feature the user acted on. Selecting it can cascade - dependent features get preselected
     * and restricted ones deselected - so it is the cause of the new selection, not the whole of it.
     */
    public readonly targetFeatureCode: string,
  ) {}
}

export class ConfigurationSummaryViewedEvent implements IEvent {
  constructor(
    public readonly shoppingContext: ShoppingContext,
    public readonly product: BaseModelData,
    public readonly selectedFeatures: ConfiguratorEventFeature[],
    public readonly configurationCode: string,
  ) {}
}
